export const timezones=[
    {
      "abbreviation": "ET",
      "description": "(UTC-05:00) Eastern Time (US & Canada)",
      "central": "US/Eastern",
      "zone": "America/New York",
      "Windows": "Eastern Standard Time"
    },
    {
      "abbreviation": "CT",
      "description": "(UTC-06:00) Central Time (US & Canada)",
      "central": "US/Central",
      "zone": "America/Chicago",
      "Windows": "Central Standard Time"
    },
    {
      "abbreviation": "MT",
      "description": "(UTC-07:00) Mountain Time (US & Canada)",
      "central": "US/Mountain",
      "zone": "America/Denver",
      "Windows": "Mountain Standard Time"
    },
    {
      "abbreviation": "PT",
      "description": "(UTC-08:00) Pacific Time (US & Canada)",
      "central": "US/Pacific",
      "zone": "America/Los Angeles",
      "Windows": "Pacific Standard Time"
    },
    {
      "abbreviation": "AK",
      "description": "(UTC-09:00) Alaska",
      "central": "America/Anchorage",
      "zone": "America/Anchorage",
      "Windows": "Alaskan Standard Time"
    },
    {
      "abbreviation": "HAST",
      "description": "(UTC-10:00) Hawaii",
      "central": "Pacific/Honolulu",
      "zone": "Pacific/Honolulu",
      "Windows": "Hawaiian Standard Time"
    },
    {
      "abbreviation": "MST",
      "description": "(UTC-07:00) Arizona",
      "central": "US/Arizona",
      "zone": "America/Phoenix",
      "Windows": "Mountain Standard Time"
    },
    {
      "abbreviation": "AST",
      "description": "(UTC-04:00) Atlantic Time (Canada)",
      "central": "Canada/Atlantic",
      "zone": "America/Aruba",
      "Windows": "Atlantic Standard Time"
    },
    {
      "abbreviation": "MOST",
      "description": "(UTC) Casablanca",
      "central": "Africa/Casablanca",
      "zone": "Africa/Casablanca",
      "Windows": "Morocco Standard Time"
    },
    {
      "abbreviation": "UTC",
      "description": "(UTC) Coordinated Universal Time",
      "central": "UTC",
      "zone": "Etc/GMT+0",
      "Windows": "UTC"
    },
    {
      "abbreviation": "GMT",
      "description": "(UTC) Dublin, Edinburgh, Lisbon, London",
      "central": "Europe/London",
      "zone": "Europe/London",
      "Windows": "GMT Standard Time"
    },
    {
      "abbreviation": "GST",
      "description": "(UTC) Monrovia, Reykjavik",
      "central": "Africa/Casablanca",
      "zone": "Africa/Casablanca",
      "Windows": "Greenwich Standard Time"
    },
    {
      "abbreviation": "WET",
      "description": "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
      "central": "Europe/Amsterdam",
      "zone": "Europe/Amsterdam",
      "Windows": "West Europe Standard Time"
    },
    {
      "abbreviation": "CET",
      "description": "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
      "central": "Europe/Belgrade",
      "zone": "Europe/Belgrade",
      "Windows": "Central Europe Standard Time"
    },
    {
      "abbreviation": "RST",
      "description": "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris",
      "central": "Europe/Brussels",
      "zone": "Europe/Copenhagen",
      "Windows": "Romance Standard Time"
    },
    {
      "abbreviation": "CEST",
      "description": "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
      "central": "Europe/Sarajevo",
      "zone": "Europe/Sarajevo",
      "Windows": "Central European Standard Time"
    },
    {
      "abbreviation": "ECT",
      "description": "(UTC+01:00) West Central Africa",
      "central": "Africa/Brazzaville",
      "zone": "Africa/Douala",
      "Windows": "W. Central Africa Standard Time"
    },
    {
      "abbreviation": "JST",
      "description": "(UTC+02:00) Amman",
      "central": "Europe/Athens",
      "zone": "Europe/Bucharest",
      "Windows": "Jordan Standard Time"
    },
    {
      "abbreviation": "GTBST",
      "description": "(UTC+02:00) Athens, Bucharest, Istanbul",
      "central": "Europe/Athens",
      "zone": "Europe/Bucharest",
      "Windows": "GTB Standard Time"
    },
    {
      "abbreviation": "MEST",
      "description": "MEST (UTC+02:00) Beirut",
      "central": "Africa/Cairo",
      "zone": "Africa/Cairo",
      "Windows": "Middle East Standard Time"
    },
    {
      "abbreviation": "EGST",
      "description": "EGST (UTC+02:00) Cairo",
      "central": "Africa/Cairo",
      "zone": "Africa/Cairo",
      "Windows": "Egypt Standard Time"
    },
    {
      "abbreviation": "SST",
      "description": "(UTC+02:00) Damascus",
      "central": "Africa/Cairo",
      "zone": "Africa/Cairo",
      "Windows": "Syria Standard Time"
    },
    {
      "abbreviation": "SAST",
      "description": "(UTC+02:00) Harare, Pretoria",
      "central": "Africa/Harare",
      "zone": "Africa/Harare",
      "Windows": "South Africa Standard Time"
    },
    {
      "abbreviation": "EET",
      "description": "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
      "central": "Europe/Helsinki",
      "zone": "Europe/Helsinki",
      "Windows": "FLE Standard Time"
    },
    {
      "abbreviation": "ISST",
      "description": "(UTC+02:00) Jerusalem",
      "central": "Asia/Jerusalem",
      "zone": "Asia/Jerusalem",
      "Windows": "Israel Standard Time"
    },
    {
      "abbreviation": "EEST",
      "description": "(UTC+02:00) Minsk",
      "central": "Asia/Jerusalem",
      "zone": "Asia/Jerusalem",
      "Windows": "E. Europe Standard Time"
    },
    {
      "abbreviation": "NMST",
      "description": "(UTC+02:00) Windhoek",
      "central": "Asia/Jerusalem",
      "zone": "Asia/Jerusalem",
      "Windows": "Namibia Standard Time"
    },
    {
      "abbreviation": "ARST",
      "description": "(UTC+03:00) Baghdad",
      "central": "Asia/Baghdad",
      "zone": "Asia/Baghdad",
      "Windows": "Arabic Standard Time"
    },
    {
      "abbreviation": "ABST",
      "description": "(UTC+03:00) Kuwait, Riyadh",
      "central": "Asia/Kuwait",
      "zone": "Asia/Kuwait",
      "Windows": "Arab Standard Time"
    },
    {
      "abbreviation": "MSK",
      "description": "(UTC+03:00) Moscow, St. Petersburg, Volgograd",
      "central": "Europe/Moscow",
      "zone": "Europe/Moscow",
      "Windows": "Russian Standard Time"
    },
    {
      "abbreviation": "EAT",
      "description": "(UTC+03:00) Nairobi",
      "central": "Asia/Kuwait",
      "zone": "Asia/Kuwait",
      "Windows": "E. Africa Standard Time"
    },
    {
      "abbreviation": "IRST",
      "description": "(UTC+03:30) Tehran",
      "central": "Asia/Tehran",
      "zone": "Asia/Tehran",
      "Windows": "Iran Standard Time"
    },
    {
      "abbreviation": "ARBST",
      "description": "(UTC+04:00) Abu Dhabi, Muscat",
      "central": "Asia/Muscat",
      "zone": "Asia/Muscat",
      "Windows": "Arabian Standard Time"
    },
    {
      "abbreviation": "AZT",
      "description": "(UTC+04:00) Baku",
      "central": "Asia/Baku",
      "zone": "Asia/Baku",
      "Windows": "Azerbaijan Standard Time"
    },
    {
      "abbreviation": "MUT",
      "description": "(UTC+04:00) Port Louis",
      "central": "Asia/Baku",
      "zone": "Asia/Baku",
      "Windows": "Mauritius Standard Time"
    },
    {
      "abbreviation": "GET",
      "description": "(UTC+04:00) Tbilisi",
      "central": "Asia/Baku",
      "zone": "Asia/Baku",
      "Windows": "Georgian Standard Time"
    },
    {
      "abbreviation": "AMT",
      "description": "(UTC+04:00) Yerevan",
      "central": "Asia/Baku",
      "zone": "Asia/Baku",
      "Windows": "Caucasus Standard Time"
    },
    {
      "abbreviation": "AFT",
      "description": "(UTC+04:30) Kabul",
      "central": "Asia/Baku",
      "zone": "Asia/Baku",
      "Windows": "Afghanistan Standard Time"
    },
    {
      "abbreviation": "YEKT",
      "description": "(UTC+05:00) Ekaterinburg",
      "central": "Asia/Tashkent",
      "zone": "Asia/Yekaterinburg",
      "Windows": "Ekaterinburg Standard Time"
    },
    {
      "abbreviation": "PKT",
      "description": "(UTC+05:00) Islamabad, Karachi",
      "central": "Asia/Tashkent",
      "zone": "Asia/Karachi",
      "Windows": "Pakistan Standard Time"
    },
    {
      "abbreviation": "WAST",
      "description": "(UTC+05:00) Tashkent",
      "central": "Asia/Tashkent",
      "zone": "Asia/Yekaterinburg",
      "Windows": "West Asia Standard Time"
    },
    {
      "abbreviation": "IST",
      "description": "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi",
      "central": "Asia/Calcutta",
      "zone": "Asia/Calcutta",
      "Windows": "India Standard Time"
    },
    {
      "abbreviation": "SLT",
      "description": "(UTC+05:30) Sri Jayawardenepura",
      "central": "Asia/Calcutta",
      "zone": "Asia/Calcutta",
      "Windows": "Sri Lanka Standard Time"
    },
    {
      "abbreviation": "NPT",
      "description": "(UTC+05:45) Kathmandu",
      "central": "Asia/Katmandu",
      "zone": "Asia/Katmandu",
      "Windows": "Nepal Standard Time"
    },
    {
      "abbreviation": "BTT",
      "description": "(UTC+06:00) Astana",
      "central": "Asia/Dhaka",
      "zone": "Asia/Dhaka",
      "Windows": "Central Asia Standard Time"
    },
    {
      "abbreviation": "BST",
      "description": "(UTC+06:00) Dhaka",
      "central": "Asia/Dhaka",
      "zone": "Asia/Dhaka",
      "Windows": "Bangladesh Standard Time"
    },
    {
      "abbreviation": "NCAST",
      "description": "(UTC+06:00) Novosibirsk",
      "central": "Asia/Almaty",
      "zone": "Asia/Dhaka",
      "Windows": "N. Central Asia Standard Time"
    },
    {
      "abbreviation": "MYST",
      "description": "(UTC+06:30) Yangon (Rangoon)",
      "central": "Asia/Rangoon",
      "zone": "Asia/Rangoon",
      "Windows": "Myanmar Standard Time"
    },
    {
      "abbreviation": "THA",
      "description": "(UTC+07:00) Bangkok, Hanoi, Jakarta",
      "central": "Asia/Bangkok",
      "zone": "Asia/Bangkok",
      "Windows": "SE Asia Standard Time"
    },
    {
      "abbreviation": "KRAT",
      "description": "(UTC+07:00) Krasnoyarsk",
      "central": "Asia/Bangkok",
      "zone": "Asia/Bangkok",
      "Windows": "North Asia Standard Time"
    },
    {
      "abbreviation": null,
      "description": "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
      "central": "Asia/Hong Kong",
      "zone": "Asia/Hong Kong",
      "Windows": "China Standard Time"
    },
    {
      "abbreviation": "IRKT",
      "description": "(UTC+08:00) Irkutsk",
      "central": "Asia/Irkutsk",
      "zone": "Asia/Irkutsk",
      "Windows": "North Asia East Standard Time"
    },
    {
      "abbreviation": "SNST",
      "description": "(UTC+08:00) Kuala Lumpur, Singapore",
      "central": "Asia/Singapore",
      "zone": "Asia/Taipei",
      "Windows": "Singapore Standard Time"
    },
    {
      "abbreviation": "AWST",
      "description": "(UTC+08:00) Perth",
      "central": "Australia/Perth",
      "zone": "Australia/Perth",
      "Windows": "W. Australia Standard Time"
    },
    {
      "abbreviation": "TIST",
      "description": "(UTC+08:00) Taipei",
      "central": "Asia/Taipei",
      "zone": "Asia/Taipei",
      "Windows": "Taipei Standard Time"
    },
    {
      "abbreviation": "UST",
      "description": "(UTC+08:00) Ulaanbaatar",
      "central": "Asia/Taipei",
      "zone": "Asia/Taipei",
      "Windows": "Ulaanbaatar Standard Time"
    },
    {
      "abbreviation": "TST",
      "description": "(UTC+09:00) Osaka, Sapporo, Tokyo",
      "central": "Asia/Tokyo",
      "zone": "Asia/Tokyo",
      "Windows": "Tokyo Standard Time"
    },
    {
      "abbreviation": "KST",
      "description": "(UTC+09:00) Seoul",
      "central": "Asia/Seoul",
      "zone": "Asia/Seoul",
      "Windows": "Korea Standard Time"
    },
    {
      "abbreviation": "YAKT",
      "description": "(UTC+09:00) Yakutsk",
      "central": "Asia/Yakutsk",
      "zone": "Asia/Yakutsk",
      "Windows": "Yakutsk Standard Time"
    },
    {
      "abbreviation": "CAUST",
      "description": "(UTC+09:30) Adelaide",
      "central": "Australia/Adelaide",
      "zone": "Australia/Adelaide",
      "Windows": "Cen. Australia Standard Time"
    },
    {
      "abbreviation": "ACST",
      "description": "(UTC+09:30) Darwin",
      "central": "Australia/Darwin",
      "zone": "Australia/Darwin",
      "Windows": "AUS Central Standard Time"
    },
    {
      "abbreviation": "EAST",
      "description": "(UTC+10:00) Brisbane",
      "central": "Australia/Brisbane",
      "zone": "Australia/Brisbane",
      "Windows": "E. Australia Standard Time"
    },
    {
      "abbreviation": "AEST",
      "description": "(UTC+10:00) Canberra, Melbourne, Sydney",
      "central": "Australia/Sydney",
      "zone": "Australia/Sydney",
      "Windows": "AUS Eastern Standard Time"
    },
    {
      "abbreviation": "WPST",
      "description": "(UTC+10:00) Guam, Port Moresby",
      "central": "Pacific/Guam",
      "zone": "Pacific/Guam",
      "Windows": "West Pacific Standard Time"
    },
    {
      "abbreviation": "TAST",
      "description": "(UTC+10:00) Hobart",
      "central": "Australia/Hobart",
      "zone": "Australia/Hobart",
      "Windows": "Tasmania Standard Time"
    },
    {
      "abbreviation": "VLAT",
      "description": "(UTC+10:00) Vladivostok",
      "central": "Asia/Vladivostok",
      "zone": "Asia/Vladivostok",
      "Windows": "Vladivostok Standard Time"
    },
    {
      "abbreviation": "SBT",
      "description": "(UTC+11:00) Magadan, Solomon Is., New Caledonia",
      "central": "Pacific/Guadalcanal",
      "zone": "Pacific/Guadalcanal",
      "Windows": "Central Pacific Standard Time"
    },
    {
      "abbreviation": "NZST",
      "description": "(UTC+12:00) Auckland, Wellington",
      "central": "Pacific/Auckland",
      "zone": "Pacific/Auckland",
      "Windows": "New Zealand Standard Time"
    },
    {
      "abbreviation": "UTC12",
      "description": "(UTC+12:00) Coordinated Universal Time+12",
      "central": "Etc/GMT-12",
      "zone": "Etc/GMT-12",
      "Windows": "UTC+12"
    },
    {
      "abbreviation": "FJT",
      "description": "(UTC+12:00) Fiji",
      "central": "Pacific/Fiji",
      "zone": "Pacific/Fiji",
      "Windows": "Fiji Standard Time"
    },
    {
      "abbreviation": "PETT",
      "description": "(UTC+12:00) Petropavlovsk-Kamchatsky - Old",
      "central": "Asia/Kamchatka",
      "zone": "Etc/GMT+12",
      "Windows": "Kamchatka Standard Time"
    },
    {
      "abbreviation": "PHOT",
      "description": "(UTC+13:00) Nuku'alofa",
      "central": "Pacific/Tongatapu",
      "zone": "Pacific/Tongatapu",
      "Windows": "Tonga Standard Time"
    },
    {
      "abbreviation": "AZOST",
      "description": "(UTC-01:00) Azores",
      "central": "Atlantic/Azores",
      "zone": "Atlantic/Azores",
      "Windows": "Azores Standard Time"
    },
    {
      "abbreviation": "CVT",
      "description": "(UTC-01:00) Cape Verde Is.",
      "central": "Atlantic/Cape Verde",
      "zone": "Atlantic/Cape Verde",
      "Windows": "Cape Verde Standard Time"
    },
    {
      "abbreviation": "ESAST",
      "description": "(UTC-03:00) Brasilia America/Sao_Paulo",
      "central": "America/Sao_Paulo",
      "zone": "America/Sao_Paulo",
      "Windows": "E. South America Standard Time"
    },
    {
      "abbreviation": "ART",
      "description": "(UTC-03:00) Buenos Aires",
      "central": "America/Buenos Aires",
      "zone": "America/Buenos Aires",
      "Windows": "Argentina Standard Time"
    },
    {
      "abbreviation": "SAEST",
      "description": "(UTC-03:00) Cayenne, Fortaleza",
      "central": "SA Eastern Standard Time",
      "zone": "SA Eastern Standard Time",
      "Windows": "SA Eastern Standard Time"
    },
    {
      "abbreviation": "GNST",
      "description": "(UTC-03:00) Greenland",
      "central": "America/Godthab",
      "zone": "America/Godthab",
      "Windows": "Greenland Standard Time"
    },
    {
      "abbreviation": "MVST",
      "description": "(UTC-03:00) Montevideo",
      "central": "America/Godthab",
      "zone": "America/Montevideo",
      "Windows": "Montevideo Standard Time"
    },
    {
      "abbreviation": "NST",
      "description": "(UTC-03:30) Newfoundland",
      "central": "Canada/Newfoundland",
      "zone": "Canada/Newfoundland",
      "Windows": "Newfoundland Standard Time"
    },
    {
      "abbreviation": "PRST",
      "description": "(UTC-04:00) Asuncion",
      "central": "Canada/Atlantic",
      "zone": "America/Aruba",
      "Windows": "Paraguay Standard Time"
    },
    {
      "abbreviation": "CBST",
      "description": "(UTC-04:00) Cuiaba",
      "central": "Canada/Atlantic",
      "zone": "America/Aruba",
      "Windows": "Central Brazilian Standard Time"
    },
    {
      "abbreviation": "SAWST",
      "description": "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
      "central": "America/Santiago",
      "zone": "America/Santiago",
      "Windows": "SA Western Standard Time"
    },
    {
      "abbreviation": "PSAST",
      "description": "(UTC-04:00) Santiago",
      "central": "America/Santiago",
      "zone": "America/Santiago",
      "Windows": "Pacific SA Standard Time"
    },
    {
      "abbreviation": "VST",
      "description": "(UTC-04:30) Caracas",
      "central": "America/Caracas",
      "zone": "America/Caracas",
      "Windows": "Venezuela Standard Time"
    },
    {
      "abbreviation": "SAPST",
      "description": "(UTC-05:00) Bogota, Lima, Quito",
      "central": "America/Bogota",
      "zone": "America/Bogota",
      "Windows": "SA Pacific Standard Time"
    },
    {
      "abbreviation": "EST",
      "description": "(UTC-05:00) Indiana (East)",
      "central": "US/East-Indiana",
      "zone": "America/Halifax",
      "Windows": "US Eastern Standard Time"
    },
    {
      "abbreviation": "CAST",
      "description": "(UTC-06:00) Central America",
      "central": "America/El_Salvador",
      "zone": "America/Mexico_City",
      "Windows": "Central America Standard Time"
    },
    {
      "abbreviation": "CST",
      "description": "(UTC-06:00) Guadalajara, Mexico City, Monterrey",
      "central": "America/Mexico_City",
      "zone": "America/Mexico_City",
      "Windows": "Central Standard Time (Mexico)"
    },
    {
      "abbreviation": "CCST",
      "description": "(UTC-06:00) Saskatchewan",
      "central": "Canada/Saskatchewan",
      "zone": "Canada/Saskatchewan",
      "Windows": "Canada Central Standard Time"
    },
    {
      "abbreviation": "MSTM",
      "description": "(UTC-07:00) Chihuahua, La Paz, Mazatlan",
      "central": "America/Chihuahua",
      "zone": "America/Mazatlan",
      "Windows": "Mountain Standard Time (Mexico)"
    },
    {
      "abbreviation": "PST",
      "description": "(UTC-08:00) Baja California",
      "central": "US/Pacific",
      "zone": "America/Los Angeles",
      "Windows": "Pacific Standard Time (Mexico)"
    },
    {
      "abbreviation": "SMST",
      "description": "(UTC-11:00) Samoa",
      "central": "Pacific/Midway",
      "zone": "Pacific/Midway",
      "Windows": "Samoa Standard Time"
    },
    {
      "abbreviation": "BIT",
      "description": "(UTC-12:00) International Date Line West",
      "central": "Etc/GMT+12",
      "zone": "Etc/GMT+12",
      "Windows": "Dateline Standard Time"
    },
    {
      "abbreviation": "PHT",
      "description": "(UTC+08:00) Philippine Standard Time",
      "central": "Asia/Hong Kong",
      "zone": "Asia/Hong Kong",
      "Windows": "Dateline Standard Time"
    }
  ];


// WEBPACK FOOTER //
// ./src/server/timezones.js